import {
    VIDFLEET_INFORMATION_REQUEST,
    VIDFLEET_INFORMATION_RESULT,
    VIDFLEET_INFORMATION_OPEN_MODAL,
    VIDFLEET_INFORMATION_CLOSE_MODAL,
    VIDFLEET_INFORMATION_SETTINGS_REQUEST,
    VIDFLEET_INFORMATION_SETTINGS_RESULT,
    VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST,
    VIDFLEET_GET_CLIP_TIME_RANGE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loadingGetVidFleetInfo: false,
    vidFleetDeviceInfoResult: null,
    resultSettigs: null,
    error: null,
    openModal: false,
    esn: null,
    resultClipTime: null,
    deviceId: null,
    timezone: null,
    clips: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case VIDFLEET_INFORMATION_OPEN_MODAL:
            return { 
                ...state, 
                openModal: true, 
                esn: action.payload.esn, 
                deviceId: action.payload.id, 
                timezone: action.payload.timezone, 
                companyId: action?.payload?.companyId,
                clips: action?.payload?.clips
            }

        case VIDFLEET_INFORMATION_CLOSE_MODAL:
            return { ...state, openModal: false, vidFleetDeviceInfoResult: null, resultSettigs: null, esn: null, resultClipTime: null, deviceId: null }

        case VIDFLEET_INFORMATION_REQUEST:
            return { ...state, loadingGetVidFleetInfo: true };

        case VIDFLEET_INFORMATION_RESULT:
            return { ...state, loadingGetVidFleetInfo: false, vidFleetDeviceInfoResult: action.payload };

        case VIDFLEET_INFORMATION_SETTINGS_REQUEST:
            return { ...state, loadingGetVidFleetInfo: true }

        case VIDFLEET_INFORMATION_SETTINGS_RESULT:
            return { ...state, resultSettigs: action.payload, loadingGetVidFleetInfo: false }

        case VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST:
            return { ...state, loadingGetVidFleetInfo: true }

        case VIDFLEET_GET_CLIP_TIME_RANGE_RESULT:
            return { ...state, loadingGetVidFleetInfo: false, resultClipTime: action.payload }

        case CLEAR_REDUX:
            return ["", "VIDFLEET_INFORMATION"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};
